<template>
  <div class="choose-alternative-methods">
    <div class="content">
      <h2>{{ $t("ChooseAlternativeMethods.title") }}</h2>

      <div class="row">
        <div class="vendor">{{ $t("ChooseAlternativeMethods.method") }}</div>
        <div class="processing">
          {{ $t("ChooseAlternativeMethods.processing") }}
        </div>
        <div v-if="region !== 'mena'" class="fee">{{ $t("ChooseAlternativeMethods.fee") }}</div>
        <div class="arrow-right"></div>
      </div>

      <InfoRowButton
        v-for="option in optionsTheme"
        method=""
        :logo="option.icon"
        :clase="option.clase"
        :processing="option.processing"
        :fee="option.fee"
        :key="option.clase"
        @click="addFunds(option.url_ar, option.url_en, option.value)"
      />

      <button class="cabinet-back" @click="back">
        <div class="icon"></div>
        {{ $t("ChooseAlternativeMethods.back") }}
      </button>
    </div>

    <p class="method-instructions">
      {{ $t("ChooseAlternativeMethods.instructionOne") }}
    </p>
  </div>
</template>

<script>
import InfoRowButton from "@/components/InfoRowButton";
import {
  getCurrentInstance,
  onMounted,
  ref,
} from "@vue/runtime-core";
import router from "@/router";
import { i18n } from "@/plugins/i18n";

export default {
  name: "ChooseAlternativeMethods",
  components: {
    InfoRowButton,
  },
  data() {
    return {};
  },
  setup() {
    let optionsTheme = ref([]);
    let region = ref(process.env.VUE_APP_CABINET_ORIGIN);


    let optionsLight = ref([]);

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    onMounted(() => {
      emitter.on("preferencesUpdated", () => {
        imgSite();
      });
    });

    const imgSite = () => {
      optionsLight.value = [];

      let platforms_pay_storage = JSON.parse(
        localStorage.getItem("DepositMethods")
      );
      platforms_pay_storage = platforms_pay_storage.alternative;
      console.log(platforms_pay_storage);
      for (let plat in platforms_pay_storage) {
        console.log(platforms_pay_storage[plat].icon);
        optionsLight.value.push({
          icon: "/assets/images/" + platforms_pay_storage[plat].icon,
          processing: platforms_pay_storage[plat].processing,
          fee: platforms_pay_storage[plat].free,
          value: plat,
          clase: platforms_pay_storage[plat].clase,
          url_ar: platforms_pay_storage[plat].url_ar,
          url_en: platforms_pay_storage[plat].url_en,
        });
      }
      optionsTheme.value = optionsLight.value;
    };
    const addFunds = (url_ar, url_en, target) => {
      const language = i18n.global.locale;
      const redirectURL =
        language === "en" ? url_en : language === "ar" ? url_ar : null;

      if (redirectURL) {
        localStorage.setItem("urlDepositMethod", redirectURL);
        router.push("/cabinet/console/add_funds/" + target).catch(() => {});
      } else {
        localStorage.removeItem("urlDepositMethod");
        router.push("/cabinet/console/add_funds/" + target).catch(() => {});
      }
    };
    const back = () => {
      router.back();
    };
    imgSite();

    return {
      optionsTheme,
      imgSite,
      addFunds,
      back,
      region,
    };
  },
};
</script>

<style scoped>
</style>
